import { Box, styled, Typography } from '@mui/material'
import { FC } from 'react'
import ToggleSwitch from '../../../inputs/ToggleSwitch'

interface Props {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  dataAutomationId: string
}

const AccessibilityMenuItem: FC<Props> = ({ label, checked, onChange, dataAutomationId }) => {
  const labelId = `accessibility-menu-${label.toLowerCase().replace(/\s+/g, '-')}`

  return (
    <MenuItemWrapper>
      {/* a11y: name the switch from this label (single announcement); the label
          text is aria-hidden so it isn't also read as standalone content */}
      <Typography id={labelId} aria-hidden variant='body2'>
        {label}
      </Typography>
      <ToggleSwitch
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        inputProps={{ 'aria-labelledby': labelId }}
        data-automation-id={dataAutomationId}
      />
    </MenuItemWrapper>
  )
}

const MenuItemWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(3),
}))

export default AccessibilityMenuItem
